
import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { toast } from "@/hooks/use-toast";

interface RFPInfoFormProps {
  formData: {
    name: string;
    description: string;
  };
  onFormChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSave: () => Promise<void>;
}

const RFPInfoForm: React.FC<RFPInfoFormProps> = ({ formData, onFormChange, onSave }) => {
  const handleBlur = async () => {
    if (!formData.name) {
      toast({
        title: "Error",
        description: "RFP name is required",
        variant: "destructive",
      });
      return;
    }

    try {
      await onSave();
      
      toast({
        title: "Success",
        description: "RFP information updated successfully",
      });
    } catch (error) {
      console.error('Error updating RFP:', error);
      toast({
        title: "Error",
        description: "Failed to update RFP information",
        variant: "destructive",
      });
    }
  };

  return (
    <Card className="bg-white dark:bg-gray-900 border-purple-100 dark:border-gray-800">
      <CardHeader className="border-b border-purple-100 dark:border-gray-800">
        <CardTitle className="text-lg text-purple-700 dark:text-gray-300">RFP Information</CardTitle>
      </CardHeader>
      <CardContent className="pt-6">
        <div className="grid gap-4 md:grid-cols-2">
          <div>
            <label htmlFor="name" className="block text-sm font-medium mb-1">RFP Name</label>
            <Input
              id="name"
              name="name"
              placeholder="Enter RFP name"
              value={formData.name}
              onChange={onFormChange}
              onBlur={handleBlur}
            />
          </div>
          <div>
            <label htmlFor="description" className="block text-sm font-medium mb-1">Description (optional)</label>
            <Textarea
              id="description"
              name="description"
              placeholder="Enter RFP description"
              value={formData.description}
              onChange={onFormChange}
              onBlur={handleBlur}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default RFPInfoForm;
